<template>
  <pb-modal v-model="_toggle" width="550" @confirm="confirmHandler">
    <template slot="header">
      캠페인 {{ mode === "write" ? "추가하기" : "수정하기" }}
    </template>

    <pb-divider>
      <pb-input
        v-model="add.name"
        size="small"
        placeholder="캠페인명을 작성해주세요."
        subTitle="캠페인명"
      />
    </pb-divider>

    <pb-divider>
      <pb-selector
        v-model="add.ksia_member"
        size="small"
        isLabel="name"
        returnType="ksia_member"
        placeholder="발주자를 선택해주세요."
        subTitle="발주자"
        :options="managers"
      />
    </pb-divider>

    <pb-divider>
      <pb-input size="small" subTitle="시작일">
        <template slot="instead">
          <datetime
            v-model="add.start_date"
            class="theme-black"
            input-id="start_date"
            type="date"
            :min-datetime="start_date_min"
            :auto="true"
            :phrases="{ ok: '적용', cancel: '닫기' }"
            :week-start="7"
            placeholder="시작일을 선택해주세요."
          />
        </template>
      </pb-input>
    </pb-divider>

    <pb-divider>
      <pb-input size="small" subTitle="종료일">
        <template slot="instead">
          <datetime
            v-model="add.end_date"
            class="theme-black"
            input-id="end_date"
            type="date"
            :min-datetime="add.start_date"
            :auto="true"
            :phrases="{ ok: '적용', cancel: '닫기' }"
            :disabled="!add.start_date"
            :week-start="7"
            placeholder="종료일을 선택해주세요."
          />
        </template>
      </pb-input>
    </pb-divider>
  </pb-modal>
</template>
<script>
import { format } from "@/components/utils";
import { isEmpty } from "@/lib/utils";

export default {
  name: "AddCampaignModal",
  data: () => ({
    add: {
      name: null,
      ksia_member: null,
      start_date: null,
      end_date: null,
    },
  }),
  props: {
    value: Boolean,
    user: Object,
    campaign: Object,
    managers: Array,
    mode: String,
    data: Object,
  },
  computed: {
    _toggle: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    start_date_min() {
      return new Date().toISOString();
    },
  },
  methods: {
    clearData() {
      this.add = {
        name: null,
        ksia_member: null,
        start_date: null,
        end_date: null,
      };
    },

    confirmHandler() {
      const { name, ksia_member, start_date, end_date } = this.add;

      if (isEmpty(name)) {
        this.$alert.error("캠페인명을 작성해주세요.");
        return;
      }

      if (isEmpty(ksia_member)) {
        this.$alert.error("발주자를 선택해주세요.");
        return;
      }

      if (isEmpty(start_date)) {
        this.$alert.error("시작일을 선택해주세요.");
        return;
      }

      if (isEmpty(end_date)) {
        this.$alert.error("종료일을 선택해주세요.");
        return;
      }

      const event = this.mode === "write" ? "insert" : "update";

      this.$emit(event, {
        ...this.add,
        start_date: format("yyyy-MM-DD", start_date),
        end_date: format("yyyy-MM-DD", end_date),
      });

      this.$emit("input", false);
    },
  },
  watch: {
    value(nVal) {
      if (nVal) {
        if (!isEmpty(this.data)) {
          this.add = this.data;
        }
      } else {
        this.clearData();
      }
    },
  },
};
</script>
<style lang="scss"></style>
